export const getUniqueValues = <T extends Record<string, any>>(
  data: T[],
  fieldName: string
) => {
  return Array.from(new Set(data.map((hotel) => hotel[fieldName].toString())));
};
